/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { ConcurrentExperience } from '@atlassian/ufo-experimental'` instead.
 */
export { ConcurrentExperience } from './experience/concurrent-experience';
/**
 * @deprecated Use `import { UFOExperience } from '@atlassian/ufo-experimental'` instead.
 */
export { UFOExperience } from './experience/experience';
/**
 * @deprecated Use `import { UFOExperienceState } from '@atlassian/ufo-experimental'` instead.
 */
export { UFOExperienceState } from './experience/experience-state';
/**
 * @deprecated Use `import { ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo-experimental'` instead.
 */
export { ExperienceTypes, ExperiencePerformanceTypes } from './experience/experience-types';
/**
 * @deprecated Use `import { GlobalPageLoadExperience } from '@atlassian/ufo-experimental'` instead.
 */
export { GlobalPageLoadExperience } from './experience/global-page-load-experience';
export {
	type AbstractExperienceConfig,
	type EndStateConfig,
} from './experience/abstract-experience';
/**
 * @deprecated Use `import { perfNowOrTimestamp } from '@atlassian/ufo-experimental'` instead.
 */
export { perfNowOrTimestamp } from './experience/perf-now-or-timestamp';
